<template>
  <div>
    <DetailIndex :userLoanRequestCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-myLoanRequest',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
